'use client';

import { ChatTab } from './ChatTab';
import { useChatTabs } from '../../../store/chatTabsStore';

type ChatTabsProps = {
  contentContainerRef: React.RefObject<HTMLDivElement | null>;
};

export function ChatTabs({ contentContainerRef }: ChatTabsProps) {
  const { chatTabs } = useChatTabs();
  return (
    <>
      {chatTabs.map((tab, index) => (
        <ChatTab
          key={tab.tabId}
          tab={tab}
          index={index}
          contentContainerRef={contentContainerRef}
        />
      ))}
    </>
  );
}
